import React from 'react';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import classes from './style/UI_pagination.module.css';
import { Button } from 'antd';
interface UI_PaginationProps {
  totalPages: number;
  currentPage: number;
  handlePageChange: (handlePageChange: number | null, decr?: boolean, increm?: boolean) => void;
}
export const UI_Pagination = ({
  totalPages,
  currentPage,
  handlePageChange,
}: UI_PaginationProps) => {
  if (totalPages === 0) {
    return <></>;
  } else {
    return (
      <div>
        {totalPages > 1 && (
          <div className={classes.pagination}>
            {currentPage > 1 && (
              <ArrowLeftOutlined
                style={{ color: '#8c8c8c', marginRight: '1rem' }}
                onClick={() => handlePageChange(null, true)}
              />
            )}
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
              <Button
                key={page}
                className={currentPage === page ? classes.activePage : classes.page}
                onClick={() => handlePageChange(page)}
              >
                {page}
              </Button>
            ))}
            {currentPage < totalPages && (
              <ArrowRightOutlined
                style={{ color: '#8c8c8c', marginRight: '1rem' }}
                onClick={() => handlePageChange(null, false, true)}
              />
            )}
          </div>
        )}
      </div>
    );
  }
};
